import { inject } from 'vue';
import { authKey } from '@/infra/injection-keys';
import type { VueAuth0InstanceType } from '../plugins/auth';

export function useAuth(): VueAuth0InstanceType {
  const auth = inject(authKey);
  if (!auth) throw new Error('Auth plugin not installed');
  return auth;
}
